import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import {
  Avatar,
  Badge,
  Box
} from '@mui/material';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Roles } from "enums/roles";
import RichiesteSupportoContainer from 'pages/components/RichiesteSupportoContainer';
import { useEffect, useState } from 'react';
import { getRichiesteSupporto } from 'services/getRichiesteSupporto';
import { sendNotificationStatus } from "services/sendNotificationStatus";
import { useRichiestaSupportoStore } from "stores/richiesta-supporto-store";
import './Footer.css';

const Footer = ({ idPratica }) => {

  const [slideDownValue, setSlideDownValue] = useState(false)
  const [showRichiesteSupporto, setShowRichiesteSupporto] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0)
  const userLogged = JSON.parse(localStorage.getItem('user'))
  const functions = JSON.parse(localStorage.getItem('functions'))
  const [rispostaSupporto, setRispostaSupporto] = useState(false)

  const { setStore: setStoreRichiestaSupporto } = useRichiestaSupportoStore();

  const {
    data: listRichiesteSupporto,
    isFetched: isListRichiesteSupportoFetched,
  } = useQuery({
    queryKey: ['richiesteSupporto', idPratica],
    queryFn: () => getRichiesteSupporto(idPratica),
    retry: false,
    refetchOnWindowFocus: false
  })

  const sendNotificationStatusMutation = useMutation({
    mutationFn: (body) => sendNotificationStatus(listRichiesteSupporto.idRichiesta, body),
  })

  useEffect(() => {

    if (listRichiesteSupporto) {
      let utenteUltimaRichiestaSupporto = null;
      const ultimoMessaggio = listRichiesteSupporto.messaggioList[listRichiesteSupporto.messaggioList.length - 1];
      if (ultimoMessaggio.tipoMessaggio.toLowerCase().includes("richiesta supporto")) {
        utenteUltimaRichiestaSupporto = ultimoMessaggio.idUtente.username;
      }

      setStoreRichiestaSupporto({ idRichiestaSupporto: listRichiesteSupporto.idRichiesta, utenteUltimaRichiestaSupporto: utenteUltimaRichiestaSupporto });

      debugger;
      const richiesteSupportoNotViewed = listRichiesteSupporto.messaggioList
        .filter(messaggio => messaggio.notificationStatus === false &&
          (messaggio.destinatario === userLogged || functions.includes(messaggio.destinatario)));


      setNotificationCount(richiesteSupportoNotViewed.length);
    }

    if (listRichiesteSupporto && listRichiesteSupporto.length > 0) {

    }

  }, [listRichiesteSupporto, setStoreRichiestaSupporto])

  const openRichiesteSupporto = (rispostaSupporto) => {
    setSlideDownValue(true)
    setRispostaSupporto(rispostaSupporto)
    setTimeout(function () {
      setShowRichiesteSupporto(true)
    }, 250)

    if (notificationCount > 0) {
      let body = { getUserFromBody: false, user: null }
      if (functions.includes(Roles.AML_DESK.role)) {
        body = { getUserFromBody: true, user: Roles.AML_DESK.role };
      }
      sendNotificationStatusMutation.mutate(body)
      setNotificationCount(0);
    }
  }
  const closeRichiesteSupporto = () => {
    setSlideDownValue(false);
    setShowRichiesteSupporto(false)
  }

  return (
    <>
      {isListRichiesteSupportoFetched && listRichiesteSupporto && listRichiesteSupporto.messaggioList.length > 0 &&
        <Box
          className={'footer ' + (slideDownValue === true ? 'animationSlideDownAndUp' : '')}
          sx={{ alignSelf: 'end', marginRight: '3%', position: 'fixed', bottom: '0px', right: '0px' }}
        >

          {showRichiesteSupporto ?
            <RichiesteSupportoContainer
              listRichiesteSupporto={listRichiesteSupporto.messaggioList}
              {...{ closeRichiesteSupporto, idPratica }}
            />
            :
            <Badge badgeContent={notificationCount ? notificationCount : 0} invisible={!notificationCount || notificationCount <= 0} sx={{ marginY: '2em' }} >
              <Avatar
                onClick={openRichiesteSupporto}
                sx={{ margin: 'auto', backgroundColor: '#0073B1', textAlign: 'center', padding: '20px', width: '65px', height: '65px' }}
              >
                <ContactSupportIcon sx={{ fontSize: 'xxx-large' }}></ContactSupportIcon>
              </Avatar>
            </Badge>
          }

        </Box>
      }
    </>
  )
}

export default Footer
